import React from 'react';
import florLogo from '../assets/florDaisiesSF.png';
import letrasLogo from '../assets/daisies_letras.png';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white mt-24">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo y descripción */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img src={florLogo} alt="Daisies" className="h-8 w-auto brightness-0 invert" />
              <img src={letrasLogo} alt="Daisies" className="h-6 w-auto brightness-0 invert" />
            </div>
            <p className="text-gray-400 text-sm">
              Tu salud en tus manos. Consultas médicas profesionales desde la comodidad de tu hogar.
            </p>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contacto</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>hola@daisies.mx</li>
              <li>Guadalajara, Jalisco, MX</li>
              <li className="pt-2">
                <div className="flex gap-3">
                  <a href="#" className="hover:text-daisies transition-colors">Instagram</a>
                  <a href="#" className="hover:text-daisies transition-colors">Facebook</a>
                  <a href="#" className="hover:text-daisies transition-colors">TikTok</a>
                </div>
              </li>
            </ul>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h4 className="font-bold text-lg mb-4">Enlaces</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="/ahora" className="hover:text-daisies transition-colors">Encuentra Especialistas</a></li>
              <li><a href="/horarios" className="hover:text-daisies transition-colors">Ver Horarios</a></li>
              <li><a href="#" className="hover:text-daisies transition-colors">Sobre Nosotros</a></li>
              <li><a href="#" className="hover:text-daisies transition-colors">Preguntas Frecuentes</a></li>
              <li><a href="#" className="hover:text-daisies transition-colors">Blog</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-bold text-lg mb-4">Legal</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="#" className="hover:text-daisies transition-colors">Términos y Condiciones</a></li>
              <li><a href="#" className="hover:text-daisies transition-colors">Aviso de Privacidad</a></li>
              <li><a href="#" className="hover:text-daisies transition-colors">Política de Cookies</a></li>
              <li><a href="#" className="hover:text-daisies transition-colors">Certificaciones</a></li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 text-center text-gray-400 text-sm">
          <p>© 2025 Daisies. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;